// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2psDb","name":"Header_name__X7pXD","birthday":"Header_birthday__2fveL","skeleton":"Header_skeleton__2PLpE"};